"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _Phone = _interopRequireDefault(require("@material-ui/icons/Phone"));

var _Place = _interopRequireDefault(require("@material-ui/icons/Place"));

var _Restaurant = _interopRequireDefault(require("@material-ui/icons/Restaurant"));

var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));

var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));

var _Header = _interopRequireDefault(require("../components/Header"));

var _Item = _interopRequireDefault(require("../components/Item"));

var _ModalLayout = _interopRequireDefault(require("../components/ModalLayout"));

var RestaurantModal = function RestaurantModal(_ref) {
  var title = _ref.title,
      reservationCode = _ref.reservationCode,
      date = _ref.date,
      address = _ref.address,
      phoneNumber = _ref.phoneNumber,
      reservationName = _ref.reservationName,
      aside = _ref.aside;
  var items = [{
    icon: /*#__PURE__*/_react["default"].createElement(_Restaurant["default"], null),
    content: reservationName
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Today["default"], null),
    content: date,
    multi: true
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Place["default"], null),
    content: address,
    multi: true
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Phone["default"], null),
    content: phoneNumber
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], null),
    content: reservationCode
  }];
  return /*#__PURE__*/_react["default"].createElement(_ModalLayout["default"], {
    aside: aside
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], null, title), items.map(function (_ref2, index) {
    var icon = _ref2.icon,
        content = _ref2.content,
        rest = (0, _objectWithoutProperties2["default"])(_ref2, ["icon", "content"]);
    return content && /*#__PURE__*/_react["default"].createElement(_Item["default"], {
      key: index,
      icon: icon,
      valign: rest.multi ? 'top' : undefined
    }, (0, _isArray["default"])(content) ? content.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: "".concat(item).concat(index)
      }, item);
    }) : content);
  }));
};

var _default = RestaurantModal;
exports["default"] = _default;
//# sourceMappingURL=Restaurant.js.map